import { useMemo } from 'react';
import { getBoatTimesOptions, getTimeOptions } from '../utils';
import { useTimePickerData } from './useTimePickerData';
import { TimePickerProps } from '../types';

export const useTimeOptions = (
  props: Pick<TimePickerProps, 'calendar' | 'useDuration'>,
  data: ReturnType<typeof useTimePickerData>
) => {
  const { calendar, useDuration } = props;
  const {
    tripStart,
    tripStartFormatted,
    defaultStartTimes,
    bookingBoatDetails,
    bookingDuration,
    selectedBookingPackage,
  } = data;

  return useMemo(() => {
    const boatTimesOptions = getBoatTimesOptions(tripStart, defaultStartTimes, bookingBoatDetails?.start_times || {});

    return getTimeOptions({
      startDate: tripStartFormatted,
      calendar,
      timeOptions: boatTimesOptions,
      useDuration,
      bookingDuration,
      selectedBookingPackage,
    });
  }, [
    tripStart,
    tripStartFormatted,
    calendar,
    defaultStartTimes,
    useDuration,
    bookingBoatDetails?.start_times,
    bookingDuration,
    selectedBookingPackage,
  ]);
};
